var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-page',{attrs:{"image":19}},[_c('h1',[_vm._v("Ошибка 404. Страница не найдена!")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }